import React, { useRef, useEffect, useState } from 'react';
import BasicButton from '../@common/Buttons/BasicButton';
import DrawnArrowCircle from 'assets/icons/DrawnArrowCircle';
import selectorBackground from 'assets/images/counter.png';
import { translate } from '../../translations/translator';
import { remCalc } from '../../util/style-util';
import { FONT_GSS_FUTURA } from 'themes/default';
import { makeStyles } from '@mui/styles';
const translateBookMenus = key => translate('bookMenus', key);

type Props = {
  totalPages: number;
  newPageNumber: string;
  handleInputChange?: (e: Event) => void;
  handleDelete: () => void;
  currentPage: string | number;
} & any;

const GoToPageHeader = ({
  totalPages,
  currentPage,
  newPageNumber,
  handleInputChange,
  handleDelete
}: Props) => {
  let pageInput: any = useRef(null);

  const classes = useStyles();

  const [hasNumberChange, setHasNumberChanged] = useState<boolean>(false);

  useEffect(() => {
    if (!pageInput) return;
    pageInput?.addEventListener('keypress', handleKeypress);
    return () => pageInput?.removeEventListener('keypress', handleKeypress);
  }, []);

  /* We only want to allow numbers and backspace for the page input.
     type="number" still allows math operators like +, -, *, e, etc. */
  const handleKeypress = (e: KeyboardEvent) => {
    const keyCode = e.keyCode;

    // Backspace/Delete keyCode
    if (keyCode === 8) return;

    // keyCode for 0 is 48, keyCode for 9 is 57
    if (keyCode < 48 || keyCode > 57) {
      e.preventDefault();
    }
  };

  const handleDeleteInput = () => {
    setHasNumberChanged(true);
    handleDelete();
  };

  const handleInput = e => {
    if (!e.target.value) setHasNumberChanged(true);
    handleInputChange(e);
  };

  return (
    <header className={classes.menuHeader}>
      <span className={classes.inputInstructions}>{translateBookMenus('goToPage')}</span>
      <input
        type="number"
        min="0"
        max={totalPages - 1}
        maxLength={totalPages.toString().length}
        placeholder={!hasNumberChange ? currentPage : '--'}
        className={classes.pageNumberInput}
        onChange={handleInput}
        value={newPageNumber}
        aria-label={translateBookMenus('enterPageNumber')}
        ref={input => (pageInput = input)}
      />
      <BasicButton
        title={translateBookMenus('deletePageNumber')}
        aria-label={translateBookMenus('deletePageButton')}
        buttonStyles={[classes.deleteButton]}
        tabIndex="0"
        onClick={handleDeleteInput}
        icon={DrawnArrowCircle}
      />
    </header>
  );
};

const useStyles = makeStyles(() => ({
  menuHeader: {
    margin: remCalc(20, 'auto'),
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexFlow: 'row nowrap'
  },
  inputInstructions: {
    verticalAlign: remCalc(5),
    fontWeight: 'normal'
  },
  pageNumberInput: {
    display: 'inline-block',
    backgroundImage: `url(${selectorBackground})`,
    backgroundSize: remCalc(93, 47),
    backgroundRepeat: 'no-repeat',
    fontFamily: `${FONT_GSS_FUTURA} !important`,
    fontSize: `${remCalc(32)} !important`,
    fontWeight: 700,
    width: remCalc(98),
    textAlign: 'center',
    backgroundColor: 'transparent',
    paddingTop: '3px',
    border: 'none',
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none'
    }
  },
  deleteButton: {
    padding: `${remCalc(4)} ${remCalc(5)} 0`
  }
}));

export default GoToPageHeader;
